import { PastaCrudApi, useClassFactory } from "@pasta/box-v2";
import { type VersionAnnouncementDto, type WriteVersionAnnouncementDto } from "./version-announcement.dto";
import { subject } from "@casl/ability";

export class VersionAnnouncementApi extends PastaCrudApi<{
  Entity: VersionAnnouncementDto;
  CreateDto: WriteVersionAnnouncementDto;
  UpdateDto: WriteVersionAnnouncementDto;
}> {
  protected readonly baseEndpoint = "versions/";

  map(entity: VersionAnnouncementDto) {
    return subject("VersionAnnouncement", entity);
  }
}

export const [versionAnnouncementApiToken, useVersionAnnouncementApi] = useClassFactory(VersionAnnouncementApi);
